import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { isNew } from '@/helpers/HelperFunctions';

const PartnerTemplate = ({ partner, locale = "de" }) => {
    const { t } = useTranslation('partners');

    return (
        <div className="col-12 col-sm-6 col-lg-4">

            {/*<!-- Card -->*/}
            <div className="card card-fill">
                <div className="card-body mt-0">

                    {/*<!-- Logo -->*/}
                    {(partner.logo) &&
                        <Link href={`/partners/${encodeURIComponent(partner.slug)}`}>
                            <a className="card-app-logo-lg card-avatar mx-auto mt-4 mb-5">
                                <img src={partner.logo.url} className="product-img" alt={partner.name} />
                            </a>
                        </Link>
                    }

                    {/*<!-- Title -->*/}
                    <h2 className="card-title">
                        <Link href={`/partners/${encodeURIComponent(partner.slug)}`}>
                            <a>{partner.name}</a>
                        </Link>
                    </h2>

                    {/*<!-- Text -->*/}
                    <p className="card-text text-muted text-left small">
                        {partner[`description_short_${locale}`]}
                    </p>

                </div>
                <div className="card-footer card-footer-boxed">
                    <div className="row align-items-center">
                        <div className="col">

                            {isNew(partner.published_at) &&
                                <span className="badge badge-soft-success">{t('new')}</span>
                            }

                        </div>
                        <div className="col-auto">
                            {/*<!-- Action Button -->*/}
                            <Link href={`/partners/${encodeURIComponent(partner.slug)}`}>
                                <a className="btn btn-primary btn-sm"><i className="fe fe-info mr-1"></i> {t('learn-more')}</a>
                            </Link>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
}

export default PartnerTemplate;
